import React, { useEffect } from 'react';
import { NextPage } from 'next';
import { useLazyQuery } from '@apollo/client';
import { useDispatch } from 'react-redux';

import Head from 'next/head';
import Layout from '@/components/Layout';
import Wizard from '@/components/Wizard';

import { useBranding, useExecutive, usePreloadMailingLead } from '@/src/customHooks';

import { withApollo } from '@/graphQL/withApollo';
import * as plansActions from '@/redux/plans/actions';

import * as ufActions from '@/redux/uf/actions';
import * as appActions from '@/redux/app/actions';
import listPlansAndUFToday from '@/graphQL/queries/listPlansAndUFToday';

const Estimate: NextPage = () => {
  const dispatch = useDispatch();
  const branding = useBranding();
  usePreloadMailingLead();

  const [getInitialData, { loading }] = useLazyQuery(listPlansAndUFToday, {
    onCompleted: (data) => {
      if (data) {
        dispatch(plansActions.setAvailablePlans(data.listPlans));
        dispatch(ufActions.setUF(data.getUFToday));
        dispatch(appActions.unsetError());
      } else {
        dispatch(appActions.setError(new Error('data not loaded')));
      }
    },
    onError: (error) => {
      dispatch(appActions.setError(error));
    },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    getInitialData({ variables: { brokerCode: branding.code } });
  }, []);

  useEffect(() => {
    dispatch(appActions.setLoading(loading));
  }, [loading]);

  useBranding();
  useExecutive();

  return (
    <Layout>
      {!branding.code ? (
        <Head>
          <script src={process.env.tidioId} async />
        </Head>
      ) : (
        <div />
      )}
      <Wizard />
    </Layout>
  );
};

export default withApollo(Estimate, {
  graphqlGateway: process.env.graphqlGateway,
});
